var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarn = function SvgWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F79E1B",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4499 46.174H44.5499C47.1165 46.174 48.7165 43.3906 47.4332 41.174L34.8832 19.4906C33.5999 17.274 30.3999 17.274 29.1165 19.4906L16.5665 41.174C15.2832 43.3906 16.8832 46.174 19.4499 46.174ZM31.9999 34.5073C31.0832 34.5073 30.3332 33.7573 30.3332 32.8406V29.5073C30.3332 28.5906 31.0832 27.8406 31.9999 27.8406C32.9165 27.8406 33.6665 28.5906 33.6665 29.5073V32.8406C33.6665 33.7573 32.9165 34.5073 31.9999 34.5073ZM33.6665 39.5073C33.6665 40.4278 32.9204 41.174 31.9999 41.174C31.0794 41.174 30.3332 40.4278 30.3332 39.5073C30.3332 38.5868 31.0794 37.8406 31.9999 37.8406C32.9204 37.8406 33.6665 38.5868 33.6665 39.5073Z",
    fill: "#F79E1B"
  })));
};
export default SvgWarn;